import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import App from './App.tsx';
import localforage from 'localforage';
import '@/components/UnityWebgl/unitySendMessageType.ts';
import { initAppUsageMetrics } from '@/utils/appInfo';
import { initUmengAnalytics } from '@/utils/umeng';

// 配置 localforage（IndexedDB/WebSQL/localStorage 回退）
localforage.config({
  name: 'acupoint-website',
  storeName: 'zustand_persist',
  description: 'Zustand persist storage',
});

initAppUsageMetrics();
initUmengAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
